import { render, staticRenderFns } from "./PersonForm.vue?vue&type=template&id=62fcb4a4&scoped=true"
import script from "./PersonForm.vue?vue&type=script&lang=js"
export * from "./PersonForm.vue?vue&type=script&lang=js"
import style0 from "./PersonForm.vue?vue&type=style&index=0&id=62fcb4a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fcb4a4",
  null
  
)

export default component.exports